import { render } from "./TraceabilityResultRow.vue?vue&type=template&id=34a64f24&ts=true"
import script from "./TraceabilityResultRow.vue?vue&type=script&lang=ts"
export * from "./TraceabilityResultRow.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/dashboard/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__